import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { OemService } from './oem.service';

import { HealthpicksComponent } from './healthpicks/healthpicks.component';
import { HealthpicksRegisterSendComponent } from './healthpicks-register-send/healthpicks-register-send.component';
import { HealthpicksResetPasswordComponent } from './healthpicks-reset-password/healthpicks-reset-password.component';
import { HealthpicksUnblockComponent } from './healthpicks-unblock/healthpicks-unblock.component';
import { HealthpicksPasswordInputComponent } from './healthpicks-password-input/healthpicks-password-input.component';
import { HealthpicksChangePasswordSentComponent } from './healthpicks-change-password-sent/healthpicks-change-password-sent.component';
import { HealthpicksLoginComponent } from './healthpicks-login/healthpicks-login.component';
import { HealthpicksForgotPasswordComponent } from './healthpicks-forgot-password/healthpicks-forgot-password.component';
import { HealthpicksFieldErrorComponent } from './healthpicks-field-error/healthpicks-field-error.component';
import { HealthpicksErrorBannerComponent } from './healthpicks-error-banner/healthpicks-error-banner.component';

@NgModule({
  declarations: [
    HealthpicksComponent,
    HealthpicksRegisterSendComponent,
    HealthpicksResetPasswordComponent,
    HealthpicksUnblockComponent,
    HealthpicksPasswordInputComponent,
    HealthpicksChangePasswordSentComponent,
    HealthpicksLoginComponent,
    HealthpicksForgotPasswordComponent,
    HealthpicksFieldErrorComponent,
    HealthpicksErrorBannerComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    HealthpicksComponent,
    HealthpicksRegisterSendComponent,
    HealthpicksResetPasswordComponent,
    HealthpicksUnblockComponent,
    HealthpicksChangePasswordSentComponent,
    HealthpicksLoginComponent,
    HealthpicksForgotPasswordComponent,
    HealthpicksFieldErrorComponent,
    HealthpicksErrorBannerComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HealthpicksModule {}
